module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-light.1bd10b5a.woff2";